import { render, staticRenderFns } from "./CategorySelector.vue?vue&type=template&id=756cc02c&scoped=true"
import script from "./CategorySelector.vue?vue&type=script&lang=ts"
export * from "./CategorySelector.vue?vue&type=script&lang=ts"
import style0 from "./CategorySelector.vue?vue&type=style&index=0&id=756cc02c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756cc02c",
  null
  
)

export default component.exports